import { admin } from "../client";
import {
  buildMutationEntityPayload,
  buildPaginatedEntityPayload,
  buildSearchEntityPayload,
  buildSignalConfig,
} from "../utils/entityRequests";

const USER_FIELDS = [
  "name",
  "email",
  "clientId",
  "businessId",
  "idRole",
  "password",
];
const USER_UPDATE_FIELDS = ["name", "status"];
const CLIENT_SCOPED_USER_FIELDS = [...USER_FIELDS, "clientIdLogin"];

export const getUser = (params) => {
  return admin.post(
    "/users/query",
    buildPaginatedEntityPayload("userData", params),
    buildSignalConfig(params)
  );
};

export const addUser = (params) => {
  return admin.post("/users", buildMutationEntityPayload("userData", params, USER_FIELDS));
};

export const searchUser = (params) => {
  return admin.post(
    "/users/search",
    buildSearchEntityPayload("userData", params),
    buildSignalConfig(params)
  );
};


export const updateUser = (params) => {
  return admin.patch(
    `/users/${params.id}`,
    buildMutationEntityPayload("userData", params, USER_UPDATE_FIELDS)
  );
};

export const getUsersRole = () => {
  return admin.get("/roles");
};

export const getUsersForClient = (params) => {
  return admin.post(
    "/users/by-client/query",
    buildPaginatedEntityPayload("userData", params, {
      clientId: params?.clientId,
    }),
    buildSignalConfig(params)
  );
};

export const addUserWithClient = (params) => {
  return admin.post(
    "/users/by-client",
    buildMutationEntityPayload("userData", params, CLIENT_SCOPED_USER_FIELDS)
  );
};

export const searchUsersWithClient = (params) => {
  return admin.post(
    "/users/by-client/search",
    buildSearchEntityPayload("userData", params, {
      clientId: params?.clientId,
    }),
    buildSignalConfig(params)
  );
};

